import { render, staticRenderFns } from "./UUploadSelectFile.vue?vue&type=template&id=8528acca&scoped=true&"
import script from "./UUploadSelectFile.vue?vue&type=script&lang=js&"
export * from "./UUploadSelectFile.vue?vue&type=script&lang=js&"
import style0 from "./UUploadSelectFile.vue?vue&type=style&index=0&id=8528acca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528acca",
  null
  
)

export default component.exports